import React, { useEffect } from 'react';
import { useAuth } from 'auth/AuthContext';
import KskTooltip from 'ksk/styledComponents/components/KskPopover/KskTooltip';
import logoPNG from 'ksk/assets/template/siconfi-no-subtitle-dark-blue.png';
import BuscaRapidaIdSiconfi from 'pages/id_siconfi/BuscaRapidaIdSiconfi';
import Credenciais from './Credenciais';
import MainMenu from '../MainMenu/MainMenu';
import ScrollTop from '../ScrollTop/ScrollTop';

function MainHeader() {
  useEffect(() => {
    if (window.core && window.core.BRHeader) {
      const brHeader = document.querySelector('.br-header');
      new window.core.BRHeader('br-header', brHeader);
    }
  }, []);

  const { credentials, reverseSignOn, isAuthenticated } = useAuth();

  return (
    // <header className="br-header">
    <header className="br-header" data-sticky={true} style={{ zIndex: 1000 }}>
      <div className="container-fluid">
        <div className="header-top">
          <div className="header-logo">
            {isAuthenticated ? (
              <KskTooltip title="Selecionar módulo do sistema"
                body="Encerra a sessão no módulo Operações de Crédito e vai para a página de seleção de módulos na Área Administrativa." popover arrow>
                <button className="header__logo" type="button" onClick={reverseSignOn} style={{ border: 'none', background: 'transparent' }}>
                  <img src={logoPNG} alt="logo" style={{ marginLeft: "8px" }} />
                </button>
              </KskTooltip>) :
              <img src={logoPNG} alt="logo" style={{ marginLeft: "8px" }} />}
          </div>
          <div className="header-actions">
            <div className="header-links dropdown">
              <button className="br-button circle small" type="button" data-toggle="dropdown"
                aria-label="Abrir Acesso Rápido">
                <i className="fas fa-ellipsis-v" aria-hidden="true"></i>
              </button>
              <div className="br-list">
                <div className="header">
                  <div className="title">Acesso Rápido</div>
                </div>
                <a className="br-item" href="https://www.gov.br/secom/pt-br/acesso-a-informacao/comunicabr" target="_blank">ComunicaBR</a>
                <a className="br-item" href="https://www.gov.br/acessoainformacao/pt-br" target="_blank">Acesso a Informação</a>
                <a className="br-item" href="https://www.gov.br/pt-br/participacao-social/" target="_blank">Participe</a>
                <a className="br-item" href="http://www4.planalto.gov.br/legislacao/" target="_blank">Legislação</a>
                <a className="br-item" href="https://www.gov.br/pt-br/orgaos-do-governo" target="_blank">Órgãos do Governo</a>
              </div>
            </div>
            <span className="br-divider vertical mx-half mx-sm-1"></span>
            <div className="header-functions dropdown">
              <button className="br-button circle small" type="button" data-toggle="dropdown"
                aria-label="Abrir Funcionalidades do Sistema"><i className="fas fa-th" aria-hidden="true"></i>
              </button>
              <div className="br-list">
                {/* <div className="br-item">
                      <button className="br-button circle small" type="button" aria-label="Alto contraste">
                          <i className="fas fa-adjust" aria-hidden="true"></i>
                          <span className="text">Alto contraste</span>
                      </button>
                  </div>
                  <div className="br-item">
                      <button className="br-button circle small" type="button" aria-label="Modo Escuro">
                          <i className="fas fa-moon" aria-hidden="true"></i>
                          <span className="text">Modo Escuro</span>
                      </button>
                  </div> */}
                <div className="br-item">
                  <a className="br-button circle small"
                    href="https://e-servicos.tesouro.gov.br/#/public/homeUsuario/Area/266361"
                    aria-label="Fale conosco"
                    title="Fale conosco"
                    target="_blank">
                    <i className="fas fa-headset" aria-hidden="true"></i>
                    <span className="text">Fale conosco</span>
                  </a>
                </div>
                <div className="br-item">
                  <a className="br-button circle small"
                    href="https://manuais.tesouro.gov.br/oc_cdp"
                    aria-label="Manual de operações de crédito e CDP"
                    title="Manual de operações de crédito e CDP"
                    target="_blank">
                    <i className="fas fa-book" aria-hidden="true"></i>
                    <span className="text">Manual de operações de crédito e CDP</span>
                  </a>
                </div>
              </div>
            </div>
            <div className="header-search-trigger">
              <button className="br-button circle" type="button" aria-label="Abrir Busca" data-toggle="search"
                data-target=".header-search">
                <i className="fas fa-search" aria-hidden="true"></i>
              </button>
            </div>
            <div className="header-login d-flex">
            
            {isAuthenticated &&
              <span className="br-avatar mr-3" title="Fulano da Silva">
                <span className="content">
                  <i className="fas fa-user" aria-hidden="true"></i>
                </span>
              </span>}

              <Credenciais className="header__credenciais" credentials={credentials} />
            </div>
          </div>
        </div>
        <div className="header-bottom">

          { isAuthenticated ? (
          <div className="header-menu" style={{ display: "flex", alignItems: "center"}}>
            <div className="header-menu-trigger">
              <button className="br-button small circle" type="button" aria-label="Menu" data-toggle="menu"
                data-target="#main-navigation" id="navigation"><i className="fas fa-bars fa-lg"
                  aria-hidden="true"></i>
              </button>
            </div>
            <div className="header-info" style={{ marginLeft: "2px", paddingTop: "0" }}>
              <div className="header-title">Operações de crédito e CDP</div>
            </div>
          </div>) : (
          <div className="header-menu">
            <div className="header-menu-trigger" hidden>
              <button className="br-button small circle" type="button" aria-label="Menu" data-toggle="menu"
                data-target="#main-navigation" id="navigation"><i className="fas fa-bars fa-lg"
                  aria-hidden="true"></i>
              </button>
            </div>
            <div className="header-info" style={{ marginLeft: "2px", paddingTop: "0" }}>
              <div className="header-title">Operações de crédito e CDP</div>
            </div>
          </div>)
          }

          <div className="header-search">
            {isAuthenticated && <BuscaRapidaIdSiconfi />}
            <button className="br-button circle search-close ml-1" type="button" aria-label="Fechar Busca" data-dismiss="search">
              <i className="fas fa-times" aria-hidden="true"></i>
            </button>
            {/* <div className="br-input has-icon">
                  <label for="searchbox-7690">Texto da pesquisa</label>
                  <input id="searchbox-7690" type="text" placeholder="Identificador Siconfi" />
                  <button className="br-button circle small" type="button" aria-label="Pesquisar">
                    <i className="fas fa-search" aria-hidden="true"></i>
                  </button>
                </div>
                <button className="br-button circle search-close ml-1" type="button" aria-label="Fechar Busca" data-dismiss="search">
                  <i className="fas fa-times" aria-hidden="true"></i>
                </button> */}
          </div>
        </div>
      </div>

      {isAuthenticated && <MainMenu />}
      
      <ScrollTop />
    </header>
  )
}

export default MainHeader;
